import React from 'react'
import { useNavigate } from 'react-router-dom'
import './fortuneHistory.css'
import homeIcon from '../assets/icon/homeIcon.png'
import { useLanguage } from '../contexts/LanguageContext'

interface FortuneRecord {
    id: string
    question: string
    subtitle: string
    date: string
    time: string
}

const FortuneHistory = () => {
    const navigate = useNavigate()
    const { t } = useLanguage()

    const handleBack = () => {
        navigate(-1)
    }

    const handleKeepAsking = (recordId: string) => {
        // TODO: 实现继续提问功能
        // console.log('Keep asking for record:', recordId)
    }

    const handleViewFullReading = (recordId: string) => {
        // TODO: 实现查看完整阅读功能
        // console.log('View full reading for record:', recordId)
    }

    // 模拟占卜历史数据
    const fortuneRecords: FortuneRecord[] = [
        {
            id: '1',
            question: "WHAT'S AHEAD FOR MY FINANCES?",
            subtitle: 'Inner Wisdom Guides Your Steady Financial Growth.',
            date: 'August 14, 2025',
            time: '10:26 PM'
        },
        {
            id: '2',
            question: "WHAT'S AHEAD FOR MY FINANCES?",
            subtitle: 'Inner Wisdom Guides Your Steady Financial Growth.',
            date: 'August 14, 2025',
            time: '10:26 PM'
        }
    ]

    return (
        <div className="fortune-history-page">
            {/* Home Button */}
            <div className="fortune-history-home-btn-container">
                <button className="fortune-history-home-btn" onClick={handleBack} aria-label="Back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5M12 19l-7-7 7-7" />
                    </svg>
                </button>
            </div>

            {/* Main Content */}
            <div className="fortune-history-content">
                {/* Header */}
                <div className="fortune-history-header">
                    <h1 className="fortune-history-title">{t.fortuneHistoryTitle}</h1>
                    <p className="fortune-history-subtitle">{t.fortuneHistorySubtitle}</p>
                </div>

                {/* Records List */}
                <div className="fortune-records-list">
                    {fortuneRecords.map((record) => (
                        <div key={record.id} className="fortune-record-card">
                            {/* Left Section - Question and Info */}
                            <div className="record-content-left">
                                <h3 className="record-question">{record.question}</h3>
                                <p className="record-subtitle">{record.subtitle}</p>
                            </div>

                            {/* Middle Section - Card Placeholders */}
                            <div className="record-cards-preview">
                                <div className="card-preview-item"></div>
                                <div className="card-preview-item"></div>
                                <div className="card-preview-item"></div>
                            </div>

                            {/* Bottom Section - DateTime and Buttons */}
                            <div className="record-bottom-section">
                                <p className="record-datetime">{record.date} — {record.time}</p>
                                <div className="record-actions">
                                    <button
                                        className="record-action-btn record-btn-keep"
                                        onClick={() => handleKeepAsking(record.id)}
                                    >
                                        {t.fortuneHistoryKeepAsking}
                                    </button>
                                    <button
                                        className="record-action-btn record-btn-view"
                                        onClick={() => handleViewFullReading(record.id)}
                                    >
                                        {t.fortuneHistoryViewFull}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default FortuneHistory

